/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

export type Country = 'NETHERLANDS' | 'BELGIUM' | 'GERMANY' | 'UKRAINE' | 'ROMANIA';

export const countryDisplayValue = (country: Country): string => {
    switch (country) {
        case 'NETHERLANDS':
            return 'Nederland';
        case 'BELGIUM':
            return 'België';
        case 'GERMANY':
            return 'Duitsland';
        case 'UKRAINE':
            return 'Oekraïne';
        case 'ROMANIA':
            return "Roemenië"
    }
};

export const parseCountryString = (countryString: string): Country => {
    if (countryString !== 'NETHERLANDS' && countryString !== 'BELGIUM' && countryString !== 'GERMANY' && countryString !== 'UKRAINE' && countryString !== 'ROMANIA')
        throw new Error('Unknown country string ' + countryString);

    return countryString;
};
